export const routeActionParam = {
    keep: 'keep',
    none: 'none',
    pageReturn: 'returnPage',
    replaceUrl: 'replaceUrl',
    routeData: 'routeData',
    skipLocationChange: 'skipLocationChange',
    store: 'store'
} as const;

export type RouteActionParam = (typeof routeActionParam)[keyof typeof routeActionParam];
